import { render, staticRenderFns } from "./Labels.vue?vue&type=template&id=87f7498e"
import script from "./Labels.vue?vue&type=script&lang=js"
export * from "./Labels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87f7498e')) {
      api.createRecord('87f7498e', component.options)
    } else {
      api.reload('87f7498e', component.options)
    }
    module.hot.accept("./Labels.vue?vue&type=template&id=87f7498e", function () {
      api.rerender('87f7498e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Labels.vue"
export default component.exports